import { Typography } from '@mui/material';

interface ProductStockMessageProps {
  quantity: number | null;
}

const ProductStockMessage = ({ quantity }: ProductStockMessageProps) => {
  const isOutOfStock = !quantity;
  const lowStockMessage =
    !isOutOfStock && quantity <= 3
      ? `¡Queda${quantity > 1 ? 'n' : ''} ${quantity} unidad${
          quantity > 1 ? 'es' : ''
        }!`
      : null;

  if (isOutOfStock) {
    return (
      <Typography
        variant="caption"
        color="InactiveCaptionText"
        fontWeight="fontWeightMedium"
        textTransform="uppercase"
        sx={{
          px: 0.6,
          pt: 1.5,
          fontSize: { xs: '0.58rem', sm: '0.63rem', md: '0.68rem' },
          lineHeight: 1,
        }}
      >
        Agotado
      </Typography>
    );
  }

  if (quantity <= 3) {
    return (
      <Typography
        variant="caption"
        color="primary"
        fontWeight="fontWeightMedium"
        sx={{
          px: 0.6,
          pt: 1.5,
          fontSize: { xs: '0.58rem', sm: '0.63rem', md: '0.68rem' },
          lineHeight: 1,
        }}
      >
        {lowStockMessage}
      </Typography>
    );
  }

  return null;
};

export default ProductStockMessage;
